import { useEffect, useState } from 'react';

/** useHasElapsed says whether `waitMs` have passed since `from`, waking once when they have. */
export const useHasElapsed = (
  from: number | undefined,
  waitMs: number,
): boolean => {
  const [now, setNow] = useState(() => Date.now());
  const isPast = from !== undefined && now - from >= waitMs;

  useEffect(() => {
    if (from === undefined || isPast) return;
    const timer = setTimeout(
      () => setNow(Date.now()),
      from + waitMs - Date.now(),
    );
    return () => clearTimeout(timer);
  }, [from, waitMs, now, isPast]);

  return isPast;
};
